const { POINTS } = require('Constants/WidgetConfig');

const ParseCurrency = (formattedNumber) => {
    const number = formattedNumber.match(/[\d\s]+((\.|,)\d+)*/g)[0];
    let integer = number.substr(0, number.length - 2);
    const currency = formattedNumber.replace(number, '');
    const decimal = currency !== POINTS ? number.slice(-2) : '';

    if (currency === POINTS) {
        integer = integer.replace('.', '');
        integer = integer.replace(',', '.');
    }

    const currencyFirst = Number.isNaN(parseInt(formattedNumber.charAt(0), 10)) && currency !== POINTS;
    return {
        integer,
        decimal,
        currency: currency === POINTS ? POINTS.toLocaleLowerCase() : currency,
        currencyFirst,
    };
};

export default ParseCurrency;
